<template>
  <div ref="introEl" class="app-intro">
    <main ref="stageEl" class="stage" aria-label="Coridor">
      <svg class="logo logo-v" viewBox="0 0 520 400" role="img" aria-label="Coridor">
        <defs><clipPath id="behindV"><rect x="380" y="20" width="580" height="140" /></clipPath></defs>
        <g class="lockup-v">
          <g transform="translate(-272.8 270.4) scale(.8)">
            <g class="wordg" clip-path="url(#behindV)">
              <g class="lv" style="--i:0"><path d="M478.5 140.3C483.8 139.6 489.3 137.9 494.7 135.4C498.8 133.5 507.3 127.1 507.3 126.0C507.3 125.3 495.5 113.7 494.9 113.7C494.5 113.7 493.5 114.3 492.6 115.1C489.3 117.8 487.2 119.0 482.6 120.8C477.9 122.7 474.9 123.1 467.9 122.9C462.3 122.8 461.6 122.7 458.5 121.8C453.6 120.3 449.5 118.0 446.1 114.9C441.0 110.1 438.0 104.5 436.5 97.1C435.8 93.6 436.0 82.9 436.8 80.2C439.4 71.0 443.7 64.8 450.0 60.8C455.9 57.0 461.9 55.3 469.7 55.2C474.1 55.2 479.4 56.0 480.2 56.7C480.3 56.9 480.8 57.0 481.1 57.0C482.0 57.0 487.5 59.6 489.0 60.6C489.6 61.1 490.9 62.1 491.7 62.8C492.7 63.6 493.5 64.0 494.0 63.9C494.7 63.8 504.7 54.5 505.6 53.1C506.1 52.3 506.0 52.2 504.8 50.9C500.8 46.8 493.0 42.2 485.7 39.8C474.8 36.1 464.0 36.2 451.0 40.1C447.5 41.2 440.4 44.8 437.2 47.1C430.2 52.3 424.1 60.5 421.0 68.8C418.6 75.2 417.7 79.7 417.4 86.7C417.1 95.7 418.2 103.0 421.3 111.0C423.9 117.6 428.9 124.6 434.3 129.3C437.7 132.1 442.8 135.1 448.2 137.4C449.5 138.0 456.6 139.7 458.8 140.0C465.7 141.0 472.9 141.1 478.5 140.3Z" /></g>
              <g class="lv" style="--i:1"><path d="M556.2 139.5C559.1 138.9 561.4 138.3 562.8 137.7C563.2 137.5 564.3 137.0 565.3 136.6C574.9 132.3 582.1 122.8 584.3 111.1C586.7 98.7 582.9 85.8 574.6 77.6C567.5 70.7 558.6 67.2 547.8 67.2C544.0 67.2 542.8 67.3 537.5 68.7C531.9 70.1 527.1 72.9 522.8 77.2C519.4 80.7 519.2 81.0 517.5 83.8C515.1 87.9 514.5 89.5 513.2 94.8C512.5 97.7 512.3 98.9 512.3 103.3C512.3 110.0 512.8 112.6 515.1 118.7C519.6 130.7 531.2 139.1 544.8 140.0C548.9 140.2 552.6 140.1 556.2 139.5ZM545.3 124.0C538.4 123.0 532.5 117.8 530.5 110.7C529.6 107.6 529.6 99.7 530.5 96.9C532.4 90.6 535.8 86.7 541.7 84.2C543.5 83.4 544.4 83.2 547.5 83.1C551.5 82.9 552.2 83.1 555.8 84.6C560.0 86.4 563.2 89.6 565.2 93.9C565.7 95.0 566.2 96.1 566.4 96.5C566.9 97.3 567.7 102.0 567.7 104.0C567.7 107.3 566.4 111.8 564.6 115.0C562.3 119.1 558.6 122.1 554.2 123.4C552.1 124.1 547.8 124.3 545.3 124.0Z" /></g>
              <g class="lv" style="--i:2"><path d="M613.7 138.1C614.0 137.8 614.1 131.8 614.2 117.7C614.2 104.1 614.4 97.5 614.6 97.1C614.8 96.7 615.0 96.0 615.0 95.6C615.0 95.2 615.5 93.8 616.2 92.4C618.3 88.2 621.8 85.7 626.8 84.6C630.7 83.8 632.8 83.9 636.6 84.7C639.0 85.2 640.1 85.6 641.7 86.7C642.8 87.4 643.9 88.0 644.2 87.9C644.4 87.8 644.8 87.3 645.1 86.8C646.1 84.8 650.5 76.2 651.1 75.2C651.9 73.6 651.8 73.2 649.8 71.7C647.5 70.0 644.6 68.6 641.2 67.6C637.6 66.6 630.1 66.5 626.5 67.5C622.3 68.6 617.7 71.6 615.8 74.5C615.5 75.0 615.0 75.3 614.7 75.3C614.2 75.3 614.0 74.9 613.7 72.9C613.5 71.6 613.2 70.1 613.1 69.7L612.8 68.8L605.3 68.7C599.2 68.7 597.7 68.7 597.4 69.1C597.1 69.5 597.0 78.5 597.1 103.9L597.2 138.2L598.3 138.4C600.3 138.8 613.3 138.5 613.7 138.1Z" /></g>
              <g class="lv" style="--i:3">
                <path d="M671.8 58.0C673.7 57.1 675.4 55.5 676.4 53.5C677.0 52.4 677.2 51.6 677.2 49.0C677.2 45.3 676.5 43.5 674.3 41.5C672.2 39.6 671.2 39.2 667.7 39.1C664.8 38.9 664.3 39.0 662.6 39.8C660.3 40.8 658.9 42.2 657.8 44.6C657.0 46.2 656.9 46.8 657.1 49.3C657.3 54.0 659.3 56.8 663.7 58.5C665.5 59.3 669.8 59.0 671.8 58.0Z" />
                <path d="M675.7 138.0C676.1 137.2 676.1 69.3 675.7 68.7C675.5 68.4 673.8 68.3 667.3 68.3C660.1 68.3 659.1 68.4 658.8 68.9C658.1 69.7 658.1 137.4 658.8 137.9C659.4 138.4 661.3 138.6 668.8 138.6C674.7 138.6 675.4 138.5 675.7 138.0Z" />
              </g>
              <g class="lv" style="--i:4"><path d="M731.7 139.3C737.2 137.9 740.1 136.3 744.0 132.3C745.4 130.9 746.7 129.8 746.8 129.9C746.9 130.0 747.0 130.6 747.0 131.3C747.0 133.1 747.9 137.6 748.3 138.1C748.8 138.7 762.9 138.9 763.6 138.3C764.2 137.8 764.2 40.3 763.6 39.7C763.3 39.4 761.0 39.3 755.5 39.3C748.9 39.3 747.6 39.4 747.2 39.9C746.7 40.3 746.7 42.5 746.7 58.3C746.7 71.3 746.6 76.4 746.3 76.5C746.1 76.7 745.3 76.1 744.5 75.3C742.1 72.7 737.3 69.9 733.3 68.7C732.0 68.3 730.5 67.8 730.0 67.6C729.5 67.4 726.8 67.1 724.0 67.1C719.6 67.0 718.3 67.0 715.5 67.6C710.6 68.7 706.1 70.4 702.7 72.5C700.3 74.1 695.7 78.7 694.2 81.2C692.5 83.7 690.0 89.1 690.0 90.0C690.0 90.4 689.9 91.0 689.7 91.3C688.4 93.7 687.7 105.5 688.6 110.7C689.5 116.1 691.8 121.7 694.7 126.1C696.2 128.3 700.1 132.2 702.5 133.8C704.2 135.0 709.6 137.7 710.8 138.0C718.0 140.0 720.6 140.3 725.7 140.1C727.4 140.0 730.1 139.6 731.7 139.3ZM721.0 123.7C717.1 122.9 712.8 120.2 710.2 117.1C707.4 113.5 706.6 111.8 705.8 107.0C704.7 100.3 706.8 93.2 711.1 88.8C712.4 87.6 716.0 85.0 716.5 85.0C716.6 85.0 717.2 84.8 717.8 84.5C718.4 84.3 719.3 83.9 719.8 83.7C720.3 83.5 722.2 83.2 723.9 83.1C727.3 82.9 729.3 83.2 733.3 84.7C737.3 86.1 741.7 90.5 743.6 94.7C744.0 95.7 744.5 96.7 744.7 97.0C744.8 97.3 745.1 99.1 745.4 100.9C745.8 104.7 745.5 107.8 744.3 111.2C742.5 116.4 736.9 121.8 732.2 123.0C731.4 123.1 730.2 123.5 729.5 123.6C728.0 124.0 722.8 124.1 721.0 123.7Z" /></g>
              <g class="lv" style="--i:5"><path d="M819.7 139.5C822.6 138.9 825.8 138.1 826.7 137.6C826.9 137.5 828.2 136.9 829.4 136.4C831.8 135.3 835.5 132.7 838.2 130.1C839.9 128.6 843.4 123.9 844.0 122.5C844.2 122.1 844.5 121.6 844.6 121.3C845.4 119.9 846.0 118.6 846.0 118.2C846.0 118.0 846.2 117.5 846.4 117.0C847.4 115.2 848.7 107.8 848.7 104.2C848.7 97.3 846.5 89.1 843.2 83.8C842.7 83.1 842.2 82.2 842.0 81.8C841.5 80.6 835.5 74.7 833.4 73.4C826.7 69.1 818.1 66.7 810.7 67.1C807.4 67.3 805.8 67.6 800.8 68.8C799.0 69.2 793.7 71.6 791.8 72.7C788.4 75.0 783.9 79.3 782.1 82.1C780.6 84.5 778.1 89.8 777.6 91.8C776.0 97.7 776.0 98.0 776.0 103.8C776.0 110.0 776.0 110.1 777.2 114.3C778.2 117.9 779.3 120.5 780.2 122.1C780.7 122.8 781.0 123.4 781.0 123.5C781.0 123.5 781.7 124.7 782.6 125.9C784.3 128.4 788.0 132.1 790.5 133.8C792.2 135.0 797.3 137.5 799.1 138.1C805.2 140.2 813.0 140.7 819.7 139.5ZM809.5 124.0C804.7 123.3 801.0 121.4 798.4 118.3C794.5 113.6 793.1 109.1 793.4 102.2C793.7 98.1 794.0 96.8 795.4 93.8C798.0 88.2 801.4 85.2 807.5 83.5C810.5 82.6 815.9 82.9 818.5 84.1C823.5 86.4 826.3 89.0 828.5 93.5C830.5 97.6 831.0 99.7 831.0 103.8C831.1 116.8 821.7 125.6 809.5 124.0Z" /></g>
              <g class="lv" style="--i:6"><path d="M877.6 138.2C877.9 138.0 878.0 133.5 878.0 117.7C878.0 98.6 878.0 97.3 878.6 95.4C879.6 92.3 880.6 90.7 882.6 88.6C886.1 85.2 890.4 83.8 896.3 84.1C901.1 84.3 902.9 85.0 906.8 87.8C907.6 88.4 908.3 87.7 909.8 84.8C910.6 83.2 912.2 80.0 913.3 77.8C914.4 75.5 915.2 73.5 915.1 73.2C914.9 72.5 911.8 70.3 910.1 69.6C904.2 67.2 902.7 66.9 897.2 66.9C893.0 66.9 891.8 67.0 889.9 67.6C886.0 68.8 883.1 70.6 880.4 73.3C877.6 76.2 877.5 76.2 877.1 72.2C877.0 70.7 876.7 69.4 876.4 69.1C876.0 68.8 874.6 68.7 868.7 68.7C864.8 68.7 861.3 68.8 861.1 69.0C860.7 69.2 860.6 75.1 860.6 103.2C860.7 121.9 860.7 137.4 860.7 137.6C860.7 137.8 861.0 138.2 861.4 138.3C862.5 138.7 877.1 138.7 877.6 138.2Z" /></g>
            </g>
          </g>

          <g transform="translate(80 10)">
            <defs>
              <!-- Kesişimler: üstte c, o'nun üzerinden; altta o, c'nin üzerinden geçer -->
              <clipPath id="xTop"><rect x="-30" y="-130" width="160" height="130" transform="translate(116.84 161.56) rotate(-24.5)" /></clipPath>
              <clipPath id="xBot"><rect x="20" y="0" width="110" height="130" transform="translate(116.84 161.56) rotate(-24.5)" /></clipPath>
              <mask id="mO" maskUnits="userSpaceOnUse" x="-300" y="-300" width="1200" height="900">
                <rect x="-300" y="-300" width="1200" height="900" fill="#fff" />
                <g class="cmove"><g clip-path="url(#xTop)"><g transform="translate(116.84 161.56) rotate(-24.5)"><path class="cring" d="M89.82 0A65.55 65.55 0 0 1 24.27 65.55L-24.27 65.55A65.55 65.55 0 0 1 -24.27 -65.55L24.27 -65.55A65.55 65.55 0 0 1 89.82 0Z" fill="none" stroke="#000" stroke-width="60.6" /></g></g></g>
              </mask>
              <mask id="mC" maskUnits="userSpaceOnUse" x="-300" y="-300" width="1200" height="900">
                <rect x="-300" y="-300" width="1200" height="900" fill="#fff" />
                <g class="cmove-inv"><g clip-path="url(#xBot)"><g transform="translate(240.49 102.14) rotate(-24.5)"><path d="M89.82 0A65.55 65.55 0 0 1 24.27 65.55L-24.27 65.55A65.55 65.55 0 0 1 -24.27 -65.55L24.27 -65.55A65.55 65.55 0 0 1 89.82 0Z" fill="none" stroke="#000" stroke-width="60.6" /></g></g></g>
              </mask>
            </defs>
            <g class="tint">
              <g class="gc"><g class="pc"><g class="cmove"><g mask="url(#mC)"><g transform="translate(116.84 161.56) rotate(-24.5)"><path class="cring" d="M89.82 0A65.55 65.55 0 0 1 24.27 65.55L-24.27 65.55A65.55 65.55 0 0 1 -24.27 -65.55L24.27 -65.55A65.55 65.55 0 0 1 89.82 0Z" fill="none" stroke="#fff" stroke-width="46.6" /></g></g></g></g></g>
              <g class="go"><g class="po"><path mask="url(#mO)" fill-rule="evenodd" fill="#fff" d="M224.8 201.5C239.2 200.2 249.4 197.1 269.8 187.5C271.2 186.9 272.4 186.3 272.5 186.3C272.6 186.3 274.2 185.6 276.2 184.7C278.1 183.8 279.9 183.0 280.1 183.0C280.2 183.0 281.5 182.4 282.9 181.7C285.7 180.3 288.6 178.9 291.8 177.6C295.0 176.2 305.0 171.2 307.4 169.7C308.5 169.0 310.2 168.0 311.0 167.5C313.6 165.9 320.4 160.8 323.1 158.4C325.8 156.0 330.6 150.9 333.6 147.2C338.4 141.4 344.4 130.7 347.0 123.5C347.6 121.9 348.3 120.0 348.5 119.3C348.9 118.2 349.3 117.0 350.5 112.0C354.4 95.6 352.9 76.8 346.5 60.5C345.3 57.7 341.2 49.0 340.3 47.5C338.3 44.3 334.9 39.3 333.1 37.0C330.5 33.7 323.8 26.8 320.5 24.0C318.1 22.0 311.1 17.0 310.8 17.0C310.7 17.0 310.0 16.6 309.2 16.0C305.4 13.4 297.1 9.8 288.0 6.7C286.5 6.2 281.2 5.0 277.8 4.5C276.0 4.2 273.5 3.8 272.3 3.6C269.1 3.0 258.5 3.1 254.2 3.8C248.7 4.6 247.4 4.9 240.4 6.5C237.5 7.2 233.0 8.7 228.5 10.5C226.4 11.3 224.7 12.0 224.5 12.0C224.4 12.0 222.6 12.8 220.4 13.9C218.3 14.9 215.6 16.1 214.5 16.6C213.4 17.0 211.0 18.1 209.1 19.0C207.2 19.9 205.6 20.7 205.5 20.7C205.4 20.7 204.0 21.3 202.3 22.1C200.7 23.0 199.0 23.7 198.6 23.9C198.2 24.0 196.8 24.6 195.5 25.2C194.2 25.8 192.6 26.5 192.0 26.8C189.5 27.8 186.1 29.5 183.2 30.9C181.5 31.8 179.7 32.7 179.2 32.9C178.0 33.5 172.4 36.8 169.8 38.4C166.4 40.6 160.4 45.4 156.7 48.8C148.0 57.2 141.2 66.7 137.0 76.8C136.3 78.7 135.5 80.5 135.3 80.8C134.1 83.6 132.5 89.5 131.2 95.7C127.8 111.9 129.3 128.7 135.6 144.8C136.5 147.4 140.3 155.3 142.0 158.3C142.6 159.6 146.9 165.9 148.1 167.5C153.3 174.3 161.8 182.3 168.4 186.7C173.5 190.1 181.0 194.1 183.7 195.0C184.1 195.2 185.3 195.6 186.3 196.0C190.0 197.5 192.7 198.3 195.2 198.8C196.6 199.1 197.9 199.4 198.0 199.5C199.1 200.2 207.2 201.3 213.8 201.6C216.2 201.8 218.4 201.9 218.7 201.9C218.9 202.0 221.7 201.8 224.8 201.5ZM215.7 154.1C209.5 153.5 207.0 152.8 201.6 150.5C196.9 148.4 194.0 146.4 190.0 142.3C184.1 136.4 181.7 132.2 178.7 122.8C177.8 120.0 177.3 112.2 177.8 107.3C178.0 106.1 178.5 103.5 179.0 101.5C180.5 96.0 182.9 91.4 187.0 86.4C192.5 79.5 197.6 76.1 213.5 69.0C216.1 67.8 219.3 66.4 220.7 65.8C222.0 65.1 224.0 64.2 225.0 63.8C228.0 62.4 228.6 62.1 233.5 59.9C236.1 58.7 239.8 57.0 241.8 56.2C243.8 55.3 245.8 54.5 246.2 54.4C254.2 50.9 266.7 50.2 274.8 52.8C281.4 55.0 286.0 57.6 291.3 62.5C294.2 65.2 297.6 69.3 299.0 71.9C299.5 73.0 301.2 76.4 301.7 77.5C303.4 81.3 304.6 87.9 304.7 93.1C304.7 106.3 297.3 119.7 285.8 127.5C283.0 129.4 273.2 134.6 271.3 135.2C270.9 135.3 268.9 136.2 266.8 137.2C262.5 139.2 260.5 140.2 256.8 141.8C251.4 144.1 248.0 145.7 245.4 146.9C239.8 149.5 239.1 149.8 236.7 150.8C235.3 151.3 232.2 152.3 229.8 152.9C226.2 153.8 224.8 154.0 221.2 154.1C218.8 154.2 216.3 154.2 215.7 154.1Z" /></g></g>
            </g>
          </g>
        </g>
      </svg>
    </main>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'

const emit = defineEmits(['done'])

// Giriş ~2 sn, ~1 sn duruş, çıkış ~0,85 sn
const ENTRY = 3050
const HOLD = 1000

const introEl = ref(null)
const stageEl = ref(null)

let state = 'entry'
let timer = null

const reduceMotion = typeof window !== 'undefined' && window.matchMedia
  ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
  : false

function end() {
  state = 'done'
  emit('done')
}

function exit() {
  if (state !== 'entry') return
  state = 'exit'
  clearTimeout(timer)

  if (document.getAnimations) {
    document.getAnimations().forEach((animation) => {
      try {
        const timing = animation.effect && animation.effect.getComputedTiming()
        if (timing && isFinite(timing.endTime)) animation.finish()
      } catch (e) {
        // Some animations can't be force-finished — safe to ignore.
      }
    })
  }

  if (reduceMotion) {
    introEl.value.style.transition = 'opacity .3s ease-out'
    introEl.value.style.opacity = '0'
    setTimeout(end, 320)
    return
  }

  // Logo bir bütün olarak kalır: c, o ve yazı birlikte hafifçe büyüyüp yumuşakça küçülerek kaybolur.
  stageEl.value.animate(
    [
      { opacity: 1, transform: 'none' },
      { opacity: 1, transform: 'scale(1.04)', offset: 0.3 },
      { opacity: 0, transform: 'scale(.74)' },
    ],
    { duration: 650, easing: 'cubic-bezier(.45,0,.55,1)', fill: 'forwards' },
  )

  const fade = introEl.value.animate(
    [{ opacity: 1 }, { opacity: 0 }],
    { duration: 420, delay: 420, easing: 'ease-out', fill: 'forwards' },
  )
  fade.onfinish = end
}

onMounted(() => {
  timer = setTimeout(exit, ENTRY + HOLD)
})

onBeforeUnmount(() => {
  clearTimeout(timer)
})
</script>

<style scoped>
.app-intro {
  position: fixed;
  inset: 0;
  z-index: 999999;
  background: #D14348;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}

.stage {
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
}
svg.logo {
  height: auto;
  overflow: visible;
  display: block;
}
.logo-v {
  width: min(62vw, 40vh, 320px);
}

.tint {
  fill: #fff;
  transform-box: fill-box;
  transform-origin: 50% 50%;
}
.po, .pc {
  transform-box: fill-box;
  transform-origin: 50% 50%;
}
/* Zincir bağı: c'nin açıklığı kapanır, o'ya geçmiş tam bir halkaya dönüşür; bir an zincir olarak durur, sonra c yeniden açılır */
.cring {
  stroke-dasharray: 284.63 528.9;
  stroke-dashoffset: -112.25;
  animation: link 1.2s cubic-bezier(.65, 0, .35, 1) .9s;
}
@keyframes link {
  0% { stroke-dasharray: 284.63 528.9; stroke-dashoffset: -112.25; }
  32%, 68% { stroke-dasharray: 512.9 528.9; stroke-dashoffset: 2; }
  100% { stroke-dasharray: 284.63 528.9; stroke-dashoffset: -112.25; }
}
/* Halka kapanırken c, o'ya doğru biraz kayar: iki halka iç içe geçer */
.cmove { animation: cm 1.2s cubic-bezier(.65, 0, .35, 1) .9s; }
.cmove-inv { animation: cmi 1.2s cubic-bezier(.65, 0, .35, 1) .9s; }
@keyframes cm { 32%, 68% { transform: translate(13px, -6px); } }
@keyframes cmi { 32%, 68% { transform: translate(-13px, 6px); } }

.po {
  opacity: 0;
  transform: translate(136px, -64px) scale(.86);
  animation: oIn .62s cubic-bezier(.2, .8, .2, 1) .08s forwards;
}
@keyframes oIn { to { opacity: 1; transform: none; } }

.pc {
  opacity: 0;
  transform: translate(-226px, 107px) rotate(-55deg);
  animation: cIn .66s cubic-bezier(.3, .7, .25, 1) .22s forwards;
}
@keyframes cIn { 40% { opacity: 1; } to { opacity: 1; transform: none; } }

/* İşaret yukarı çıkar, yazı altından yükselir (her ekranda alt alta) */
.lockup-v {
  transform: translateY(58px);
  animation: shiftV .6s cubic-bezier(.65, 0, .25, 1) 2.1s forwards;
}
@keyframes shiftV { to { transform: none; } }

.lv {
  fill: #fff;
  opacity: 0;
  transform: translateY(80px);
  animation: lin .55s cubic-bezier(.2, .8, .2, 1) calc(2.24s + var(--i) * 45ms) forwards;
}
@keyframes lin { to { opacity: 1; transform: none; } }

@media (prefers-reduced-motion: reduce) {
  .tint, .po, .pc, .cmove, .cmove-inv, .cring, .lockup-v, .lv {
    animation: none;
    transform: none;
    opacity: 1;
  }
  .stage { animation: fade .4s ease-out both; }
  @keyframes fade { from { opacity: 0; } }
}
</style>
